import { useState } from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { HypoButton } from './hypo-button';
import { HypoChart } from './hypo-chart';
import styled from 'styled-components';

export const NumberHypoEventPart = ({ HypoglycemiaChartData, patientId }) => {
  const [active, setActive] = useState('total');
  return (
    <StyledHypoChartContainer>
      <Grid
        container
        sx={{
          backgroundColor: { xs: '#FFFFFF', md: 'transparent' },
          padding: { xs: '15px 0 28px', md: '15px 0 98px' }
        }}
      >
        <Grid container>
          <p className="title">Number of Hypoglycemia Events:</p>
          <Box
            sx={{
              margin: 'auto',
              padding: { xs: '4px 0 17px', md: '64px 0 100px' }
            }}
          >
            <HypoChart
              HypoglycemiaChartData={HypoglycemiaChartData}
              active={active}
            />
          </Box>
        </Grid>
        <HypoButton
          active={active}
          setActive={setActive}
          patientId={patientId}
        />
      </Grid>
    </StyledHypoChartContainer>
  );
};

const StyledHypoChartContainer = styled.div`
  .title {
    color: #d81d5d;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 1px;
    text-align: center;
    direction: ltr;
    width: 100%;
  }
  @media screen and (min-width: 1024px) {
    .title {
      font-size: 24px;
    }
  }
`;
